(function () {
  function getProduct() {
    var script = document.querySelector('script[data-section-type="page-product"][data-section-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent).product;
    } catch (e) {
      return null;
    }
  }

  // Common Japanese counting-unit words used across product variant titles
  // (e.g. "100部", "50枚 1セット"). Add more here as new products need it.
  var UNIT_WORDS = ['部', '枚', '冊', '個', '本'];

  function parseCountAndUnit(title) {
    if (!title) return null;
    for (var i = 0; i < UNIT_WORDS.length; i++) {
      var unit = UNIT_WORDS[i];
      var m = title.match(new RegExp('([0-9]+)\\s*' + unit));
      if (m) return { count: parseInt(m[1], 10), unit: unit };
    }
    return null;
  }

  function currentSelections() {
    var selects = document.querySelectorAll('.spec-options .single-option-selector');
    var values = [];
    selects.forEach(function (sel) {
      values.push(sel.value);
    });
    return values;
  }

  function currentQuantity() {
    var input = document.getElementById('quantity');
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    return n > 0 ? n : 1;
  }

  function findVariant(product, selections) {
    if (!product || !product.variants) return null;
    if (!selections.length) return product.variants[0];
    return product.variants.filter(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
      return selections.every(function (val, i) { return opts[i] === val; });
    })[0];
  }

  function update() {
    var product = getProduct();
    var variant = findVariant(product, currentSelections());
    // {{ product | json }} serializes variant.price in cents (e.g. 110000
    // for ¥1,100), matching Shopify's internal representation — divide by
    // 100 to get yen before computing prices from it.
    var priceYen = variant ? parseFloat(variant.price) / 100 : null;

    updatePerUnit(variant, priceYen);
    updateTotal(priceYen);
  }

  // "1部単価"-style display — only shown on products whose variant title
  // encodes a count (e.g. "100部"), so it's a no-op everywhere else.
  function updatePerUnit(variant, priceYen) {
    var unitEl = document.querySelector('[data-per-unit-price]');
    if (!unitEl) return;
    var parsed = variant ? parseCountAndUnit(variant.title) : null;

    if (!parsed || !parsed.count || !priceYen) {
      unitEl.hidden = true;
      unitEl.textContent = '';
      return;
    }

    var unitPrice = Math.round(priceYen / parsed.count);
    unitEl.hidden = false;
    unitEl.textContent = '1' + parsed.unit + '単価 ' + unitPrice.toLocaleString('ja-JP') + '円';
  }

  // 注文数（quantity of sets) isn't part of the variant itself, so the
  // theme's own price element only ever shows the price for ONE set. Scale
  // it by the quantity stepper so the total reflects what the customer is
  // actually about to order. Applies to every product with a quantity
  // field, not just the サンプル請求可 ones.
  function updateTotal(priceYen) {
    var totalEl = document.querySelector('[data-variant-price]');
    if (!totalEl || priceYen === null || isNaN(priceYen)) return;
    var qty = currentQuantity();
    var total = Math.round(priceYen * qty);
    totalEl.textContent = total.toLocaleString('ja-JP') + '円';
  }

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('single-option-selector')) {
      update();
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.id === 'quantity') {
      update();
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.id === 'quantity') {
      update();
    }
  });
  window.addEventListener('load', update);
  document.addEventListener('DOMContentLoaded', update);
})();
